import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { AddonBlueprint } from '@backstage/plugin-techdocs-react/alpha';
import { TechDocsAddonLocations } from '@backstage/plugin-techdocs-react';
import { AddKatexRendering } from './AddKatexRendering';

const katexAddon = AddonBlueprint.make({
  name: 'katex',
  params: {
    name: 'Katex',
    location: TechDocsAddonLocations.Content,
    component: AddKatexRendering,
  },
});

export default createFrontendModule({
  pluginId: 'techdocs',
  extensions: [katexAddon],
});
